import { render } from "./InspirationsNavigation.vue?vue&type=template&id=a173a80c&scoped=true"
import script from "./InspirationsNavigation.vue?vue&type=script&lang=js"
export * from "./InspirationsNavigation.vue?vue&type=script&lang=js"

import "./InspirationsNavigation.vue?vue&type=style&index=0&id=a173a80c&lang=scss&scoped=true"

import exportComponent from "/web/bathroom-web2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a173a80c"]])

export default __exports__